export default __webpack_public_path__ + "static/mark-mobile-640ef710d7b7ee7ffd981fb77dfea3a7.png";